import React from 'react';

import {
  Container,
  PaymentMethodInfo,
  PaymentTitle,
  PaymentInfo,
  Payment,
  BrandContainer,
  BrandAddIcon,
  PaymentBrandsImage,
  BannerContainer,
  BannerButton,
  Banner,
} from './styles';

import valesAceitos from '../../../../assets/images/vales-aceitos_pluxee.webp';
import cartoesAceitos from '../../../../assets/images/cartoesAceitos.webp';
import {RFValue} from 'react-native-responsive-fontsize';
import {Badge} from '../../../Interface/Badges/Badge';

import {BannerCarousel} from '../../BannerCarousel';

import {useNavigation} from '@react-navigation/native';

import {useTheme} from 'styled-components/native';

type Props = {
  enableVale?: boolean;
  banners?: PaymentMethodItemFooterBanners;
};

export type PaymentMethodItemFooterBanners =  {
    id: string;
    imageUrl: any;
    action: () => void;
}[]

export function ChangePaymentMethodItem({enableVale, banners}: Props) {
  const theme = useTheme();
  const navigation = useNavigation();
  function handleAddCard(voucher: boolean) {
    navigation.navigate('AddCreditCard', {voucher});
  }

  return (
    <Container>
      {enableVale && (
        <PaymentInfo activeOpacity={1} onPress={() => handleAddCard(true)}>
          <Payment>
            <BrandContainer>
              <BrandAddIcon name="plus" />
            </BrandContainer>

            <PaymentMethodInfo style={{marginLeft: RFValue(12)}}>
              <PaymentTitle style={{marginLeft: 0}}>
                Adicionar vale
                <Badge
                  text="Novo!"
                  containerStyle={{
                    backgroundColor: theme.colors.blue,
                    borderColor: theme.colors.blue,
                    marginLeft: RFValue(6),
                    marginBottom: -RFValue(3),
                  }}
                  textStyle={{
                    color: theme.colors.shape,
                    fontSize: RFValue(8),
                  }}
                />
              </PaymentTitle>
              <PaymentBrandsImage
                source={valesAceitos}
                style={{
                  width: RFValue(52),
                  height: RFValue(16),
                }}
                resizeMode="stretch"
              />
            </PaymentMethodInfo>
          </Payment>
        </PaymentInfo>
      )}

      <PaymentInfo activeOpacity={1} onPress={() => handleAddCard(false)}>
        <Payment>
          <BrandContainer>
            <BrandAddIcon name="plus" />
          </BrandContainer>
          <PaymentMethodInfo style={{marginLeft: RFValue(12)}}>
            <PaymentTitle style={{marginLeft: 0}}>
              Adicionar cartão de crédito
            </PaymentTitle>

            <PaymentBrandsImage
              source={cartoesAceitos}
              style={{
                width: RFValue(150),
              }}
              resizeMode="stretch"
            />
          </PaymentMethodInfo>
        </Payment>
      </PaymentInfo>

      {banners && banners.length > 0 && (
        <BannerContainer>
          {banners.length === 1 ? (
            <BannerButton
              key={banners[0].id}
              activeOpacity={1}
              style={{
                shadowColor: theme.colors.border,
                shadowOffset: {width: 0, height: 4},
                shadowOpacity: 0.6,
                shadowRadius: 4,
                elevation: 8,
              }}
              onPress={() => banners[0].action()}>
              <Banner source={banners[0].imageUrl} />
            </BannerButton>
          ) : (
            <BannerCarousel
              data={banners}
              renderItem={({item}) => (
                <BannerButton
                  key={item.id}
                  activeOpacity={1}
                  style={{
                    shadowColor: theme.colors.border,
                    shadowOffset: {width: 0, height: 4},
                    shadowOpacity: 0.6,
                    shadowRadius: 4,
                    elevation: 8,
                  }}
                  onPress={() => item.action()}>
                  <Banner source={item.imageUrl} />
                </BannerButton>
              )}
            />
          )}
        </BannerContainer>
      )}


    </Container>
  );
}
